import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios, parseFilters } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
import { getSubscriptionFilters } from '@/helpers/permissions'
import i18n from '@/i18n/i18n'

const initialState = () => {
  return {
    module: 'subscriptions',
    model: 'subscription',
    loading: false,
    list: [],
    filters: {},
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
    },
    totalItems: 0,
  }
}

const state = initialState()

const getters = {
  formatedList(state) {
    return state.list.map((item) => ({
      ...item,
      startAt: formatDate(item.startAt, true),
      expireAt: formatDate(item.expireAt, true),
      createdAt: formatDate(item.createdAt, true),
      typePayment: item.typePayment
        ? i18n.t(
            `fields.typeSubscriptions.typesPayment.${
              item.typePayment.split('-')[0]
            }`
          )
        : '--',
    }))
  },
}

const actions = {
  ...baseActions,

  async fetchList({ commit, state }, params = {}) {
    let { body, query } = parseFilters(
      state,
      params,
      getSubscriptionFilters(params)
    )

    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/format', body, { params: { ...query } })
      .finally(() => commit('setLoading', false))

    state.totalItems = data.paginate ? data.paginate.totalData : 0

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async getLinkedAccountList(_, subscriptionId) {
    const { data } = await apiAxios.get(
      `subscriptions/${subscriptionId}/linkedAccounts`
    )
    const list = data.data ? data.data['subscriptions'] : []
    return list
  },

  async setLinkedAccount(_, _data) {
    /* const { data } =  */ await apiAxios
      .put('/subscriptions/assign-user/subscribers', _data)
      .then(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.assignSuccess'),
          color: 'success',
          timeout: 2000,
        })
      })
      .catch(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.assignError'),
          color: 'danger',
          timeout: 2000,
        })
      })
  },

  async getParentList(_, userId) {
    const { data } = await apiAxios.get(
      `/users/parent-list/all?userId=${userId}`
    )
    const list = data.data ? data.data['parentList'] : []
    return list
  },

  async assignSubscription(_, subscription) {
    await apiAxios
      .get(
        `subscriptions/${subscription.sub}/entity/${subscription.userIds[0]}`
      )
      .then(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.assignSuccess'),
          color: 'success',
          timeout: 2000,
        })
      })
      .catch((error) => {
        vuetifyToast.show({
          text: error.response.data.error,
          color: 'danger',
          timeout: 2000,
        })
      })
  },

  async assignDirectSubscription(_, data) {
    await apiAxios
      .post('/subscriptions/direct-user', data)
      .then(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.assignSuccess'),
          color: 'success',
          timeout: 2000,
        })
      })
      .catch((error) => {
        vuetifyToast.show({
          text: error.response.data.error,
          color: 'danger',
          timeout: 2000,
        })
      })
  },

  async cancelSubscription(_, subscriptionId) {
    await apiAxios
      .put(`subscriptions/only-cancel/${subscriptionId}`)
      .then(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.cancelSuccess'),
          color: 'success',
          timeout: 2000,
        })
      })
      .catch(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.cancelError'),
          color: 'danger',
          timeout: 2000,
        })
      })
  },

  async refundSubscription(_, subscriptionId) {
    await apiAxios
      .post(`subscriptions/refund-subscription/${subscriptionId}`)
      .then(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.refundSuccess'),
          color: 'success',
          timeout: 2000,
        })
      })
      .catch(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.refundError'),
          color: 'danger',
          timeout: 2000,
        })
      })
  },

  async deleteSubscription(_, subscriptionId) {
    await apiAxios
      .delete(`subscriptions/${subscriptionId}`)
      .then(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.deleteSuccess'),
          color: 'success',
          timeout: 2000,
        })
      })
      .catch(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.deleteError'),
          color: 'danger',
          timeout: 2000,
        })
      })
  },

  async cancelRefundSubscription(_, userId) {
    await apiAxios
      .delete(`subscriptions/cancel-refund/${userId}`)
      .then(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.assignSuccess'),
          color: 'success',
          timeout: 2000,
        })
      })
      .catch(() => {
        vuetifyToast.show({
          text: i18n.t('titles.subscriptions.assignError'),
          color: 'danger',
          timeout: 2000,
        })
      })
  },
}

const mutations = {
  ...baseMutations,
  // eslint-disable-next-line no-unused-vars
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  reset(state) {
    state.selected = initialState().selected
    state.idSelected = ''
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
